module.exports = __webpack_public_path__ + "static/media/JSNLC1.7a8cedec.png";